function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgFullscreen = function SvgFullscreen(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "512pt",
    height: "512pt",
    viewBox: "0 -51 512 512"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M0 0v410h512V0Zm482 380H30V30h452Zm0 0",
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "#000",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M180.375 310h-59.16l92.89-92.895-21.21-21.21L100 288.785v-59.16H70V340h110.375ZM319.105 214.105 412 121.215v59.16h30V70H331.625v30h59.16l-92.89 92.895Zm0 0",
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "#000",
      fillOpacity: 1
    }
  }));
};
export { SvgFullscreen as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIGhlaWdodD0iNTEycHQiIHZlcnNpb249IjEuMSIgdmlld0JveD0iMCAtNTEgNTEyIDUxMiIgd2lkdGg9IjUxMnB0Ij4KPGcgaWQ9InN1cmZhY2UxIj4KPHBhdGggZD0iTSAwIDAgTCAwIDQxMCBMIDUxMiA0MTAgTCA1MTIgMCBaIE0gNDgyIDM4MCBMIDMwIDM4MCBMIDMwIDMwIEwgNDgyIDMwIFogTSA0ODIgMzgwICIgc3R5bGU9IiBzdHJva2U6bm9uZTtmaWxsLXJ1bGU6bm9uemVybztmaWxsOnJnYigwJSwwJSwwJSk7ZmlsbC1vcGFjaXR5OjE7IiAvPgo8cGF0aCBkPSJNIDE4MC4zNzUgMzEwIEwgMTIxLjIxNDg0NCAzMTAgTCAyMTQuMTA1NDY5IDIxNy4xMDU0NjkgTCAxOTIuODk0NTMxIDE5NS44OTQ1MzEgTCAxMDAgMjg4Ljc4NTE1NiBMIDEwMCAyMjkuNjI1IEwgNzAgMjI5LjYyNSBMIDcwIDM0MCBMIDE4MC4zNzUgMzQwIFogTSAxODAuMzc1IDMxMCAiIHN0eWxlPSIgc3Ryb2tlOm5vbmU7ZmlsbC1ydWxlOm5vbnplcm87ZmlsbDpyZ2IoMCUsMCUsMCUpO2ZpbGwtb3BhY2l0eToxOyIgLz4KPHBhdGggZD0iTSAzMTkuMTA1NDY5IDIxNC4xMDU0NjkgTCA0MTIgMTIxLjIxNDg0NCBMIDQxMiAxODAuMzc1IEwgNDQyIDE4MC4zNzUgTCA0NDIgNzAgTCAzMzEuNjI1IDcwIEwgMzMxLjYyNSAxMDAgTCAzOTAuNzg1MTU2IDEwMCBMIDI5Ny44OTQ1MzEgMTkyLjg5NDUzMSBaIE0gMzE5LjEwNTQ2OSAyMTQuMTA1NDY5ICIgc3R5bGU9IiBzdHJva2U6bm9uZTtmaWxsLXJ1bGU6bm9uemVybztmaWxsOnJnYigwJSwwJSwwJSk7ZmlsbC1vcGFjaXR5OjE7IiAvPgo8L2c+Cjwvc3ZnPg==";